/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Time_Just_NowInputs */

const en_notifications_time_just_now = /** @type {(inputs: Notifications_Time_Just_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`just now`)
};

const pl_notifications_time_just_now = /** @type {(inputs: Notifications_Time_Just_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`przed chwilą`)
};

/**
* | output |
* | --- |
* | "just now" |
*
* @param {Notifications_Time_Just_NowInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const notifications_time_just_now = /** @type {((inputs?: Notifications_Time_Just_NowInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Time_Just_NowInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_notifications_time_just_now(inputs)
	return en_notifications_time_just_now(inputs)
});